export default "__VITE_PUBLIC_ASSET__616251c3__"